import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UnleashClient } from 'unleash-proxy-client';

@Injectable({
  providedIn: 'root',
})
export class UnleashService {
  public unleash: UnleashClient;
  constructor() {}

  public async IntiateUnLeash() {
    if (environment.unleash.enabled) {
      this.unleash = new UnleashClient({
        url: environment.unleash.url,
        clientKey: environment.unleash.clientKey,
        appName: environment.unleash.appName,
        refreshInterval: 60,
      });
      await this.unleash.start();
    }
  }

  public isEnabled(featureName: string): boolean {
    if (!this.unleash) {
      console.warn('Unleash client is not initialized');
      return true;
    }
    return this.unleash.isEnabled(featureName);
  }
}
